"use client";
import { Button, Heading, Inline, Stack, Text } from "@/design-system";
import Link from "next/link";
import { useRouter } from "next/navigation";

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="relative flex h-screen w-full items-center justify-center">
      <Stack gap="lg" className="items-center">
        <Stack gap="xs" className="items-center">
          <Heading level={2} weight="medium">Page not found</Heading>
          <Text as="p" size="sm" tone="tertiary">The page you're looking for doesn't exist or has been moved.</Text>
        </Stack>
        <Inline gap="sm">
          <Button onClick={() => router.back()}>
            Go back
          </Button>
          <Button asChild variant="secondary">
            <Link href="/" prefetch={false}>Go to home</Link>
          </Button>
        </Inline>
      </Stack>
    </div>
  );
}
